import { makeStyles } from 'tss-react/mui';

const name = 'GRPCEndpoints';

export const useGRPCEndpointsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),

    paddingTop: theme.spacing(6),

    borderTop: `1px solid ${theme.palette.divider}`,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
    },
  },
}));
